<template>
  <div class="sp_float_menu">
  <nav>
    <ul>
      <li class="bg-request"><a href="https://area18.smp.ne.jp/area/switch/00011K00053Aeeq0Ka/catalog" target="_blank">資料請求</a></li>
      <li class="bg-reserve"><a href="https://35s.co.jp/chukyotvh/menu/reservation/" target="_blank">見学予約</a></li>
      <li class="bg-company"><a href="https://100ie-jiten.com/">建築事例いっぱい<img src="../assets/img/logo/ttl-logo_hyakka.png" width="" height="" alt="百家辞典"></a></li>
    </ul>
  </nav>
</div>
</template>
<script>
export default {
  name: 'spFootMenu',
  props: {
    msg: String
  }
}
</script>